var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-error-dialog',{attrs:{"title":"Unable to export"},model:{value:(_vm.showError),callback:function ($$v) {_vm.showError=$$v},expression:"showError"}},[_vm._v(" There is no data to export. ")]),_c('app-icon-button',{attrs:{"color":"primary","icon":"mdi-microsoft-excel"},on:{"click":_vm.exportToExcel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }